import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10cf4442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { ref, computed, reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/social_security_bureau_datas/check': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    type: "TIME",
    label: "年度",
    value: dayjs().startOf('year').format('YYYY-MM-DD'),
    upKey: 'payDate',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'year',
      clearable: true,
    }
  },
])


let compareData = computed(() => {
  return MI_tableData.value.reduce((arr, month) => {
    arr.push(
      Object.assign(month.distribute, {rowType: '发放清单', }),
      Object.assign(month.social, {rowType: '社保统计', }),
      Object.assign(month.diffAmount, {rowType: dayjs(month.month).format('YYYY-MM'), userList: month.userList})
    )
    return arr
  }, [])
})

const compareDifFg = ref<boolean>(false)
const compareDifTit = ref<string>('')
  let personalData: any = ref([])
let compareUserTable = ref([])
const showUserDetails = (row: any, ) => {
  personalData.value = []
  compareUserTable.value = row.userList
  compareDifTit.value = dayjs(row.rowType).format('YYYY-MM') + '对比差异'
  compareDifFg.value = true
}


// 点击用户展示详情

let currentDisplayUser: any = reactive({})
const showDetails = (row: any) => {
  // costVo成本统计，salaryVo发放清单
  personalData.value = [
    Object.assign(row.distribute, {rowType: '发放清单'}),
    Object.assign(row.social, {rowType: '社保统计'}),
    Object.assign(row.diffAmount, {rowType: '差异'})
  ]
  Object.assign(currentDisplayUser, row)
  ElMessage('已选择')
}
// ----------------------
const tableRowClassName = ({row, rowIndex}: any) => {
  if (row.userList) {
    return 'compare-row'
  }
  return ''
}



return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "社保校验-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, {
              onSearchFn: _cache[0] || (_cache[0] = ($event: any) => (_unref(fetchData)($event, {}, 1)))
            }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(compareData),
      "row-class-name": tableRowClassName,
      "max-height": _unref(MI_height)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "类型",
          prop: "rowType",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            (row.userList)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  type: "primary",
                  onClick: ($event: any) => (showUserDetails(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.rowType + '差异'), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.rowType), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "个人社保总计",
          prop: "personalInsuranceTotal",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "个人公积金",
          prop: "personalHousingFund",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "公司养老",
          prop: "companyEndowment",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "公司医保",
          prop: "companyMedical",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "公司工伤",
          prop: "companyInjury",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "公司生育",
          prop: "companyMaternity",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "公司失业",
          prop: "companyUnemployment",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "公司公积金",
          prop: "companyHousing",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "公司社保总计",
          prop: "companyTotal",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      width: "92%",
      modelValue: compareDifFg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compareDifFg).value = $event)),
      title: compareDifTit.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  ref: "tb",
                  border: "",
                  data: _unref(compareUserTable),
                  "max-height": _unref(MI_height) - 150 + 'px'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "员工",
                      prop: "realName",
                      "show-overflow-tooltip": ""
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_link, {
                          onClick: ($event: any) => (showDetails(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.realName + ' (' + row.alias + ')'), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data", "max-height"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                (_unref(currentDisplayUser).realName)
                  ? (_openBlock(), _createBlock(_component_el_descriptions, {
                      key: 0,
                      column: "1",
                      border: "",
                      class: "mb-10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_descriptions_item, { label: "当前查看" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(currentDisplayUser).realName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_descriptions_item, { label: "原因" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(currentDisplayUser).remarks), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table, {
                  data: _unref(personalData),
                  border: "",
                  "max-height": _unref(MI_height) - 150 + 'px'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "类型",
                      prop: "rowType",
                      "show-overflow-tooltip": ""
                    }),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "个人社保",
                      prop: "personalInsuranceTotal",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "个人公积金",
                      prop: "personalHousingFund",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司养老",
                      prop: "companyEndowment",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司医保",
                      prop: "companyMedical",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司工伤",
                      prop: "companyInjury",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司生育",
                      prop: "companyMaternity",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司失业",
                      prop: "companyUnemployment",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"]),
                    _createVNode(_component_el_table_column, {
                      align: "right",
                      formatter: _unref(formatNumber),
                      label: "公司公积金",
                      prop: "companyHousing",
                      "show-overflow-tooltip": ""
                    }, null, 8, ["formatter"])
                  ]),
                  _: 1
                }, 8, ["data", "max-height"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})